import { render, staticRenderFns } from "./CipWarning.vue?vue&type=template&id=4158873a&scoped=true"
import script from "./CipWarning.vue?vue&type=script&lang=js"
export * from "./CipWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158873a",
  null
  
)

export default component.exports